<div class="row">
    <div class="col-1">
      <app-back-button></app-back-button>
    </div>
    <div class="col">
      <h2 class="h2-responsive text-center">{{label.label}}</h2>
    </div>
  </div>
<div class="row">
  <mdb-tabset #staticTabs [buttonClass]="'col nav-tabs tabs-3 primary-color p-1'" [contentClass]="'card'" class="col-12">
    <mdb-tab heading="General Settings" [customClass]="'order-1'">
      <form>
        <div class="form-group">
            <label for="label">Label:</label>
            <input class="form-control" type="text" id="label" name="label" [(ngModel)]="label.label" />
          </div>
        <!--<div class="form-group">
              <label for="displayOrder">Display Order:</label>
          <input class="form-control" type="number" id="displayOrder" name="displayOrder" [(ngModel)]="ctrl.label.display_order" />
        </div>-->
        <div class="form-group">
          <input class="form-control" type="checkbox" id="skip-scoring" name="skip-scoring" [checked]="label.skipScoring" [(ngModel)]="label.skipScoring" />
          <label for="skip-scoring">Skip Scoring: (N/A questions)</label>
        </div>
      </form>
      <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
      <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
    </mdb-tab>
  </mdb-tabset>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/label-edit/label-edit.component.html